<template>
<div id="pageTable">
    <div class="page-header-left pa-3 pt-8">
        <h4>Tài khoản</h4>
    </div>
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="currentItem.phone" ref="username" label="User Name" class="input-group--focused" disabled></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="currentItem.email" label="Email" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="currentItem.first_name" label="Họ tên" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-select v-model="currentItem.role" :items="role_list" item-text="name" item-value="value" label="Quyền hạn" disabled class="input-group--focused"></v-select>
                </v-flex>                
                <v-flex lg12 md12 sm12>
                    <v-checkbox v-model="change_pass" label="Đổi mật khẩu" class="input-group--focused"></v-checkbox>
                </v-flex> 
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="password" type="password" label="Mật khẩu mới" :disabled="!change_pass" class="input-group--focused"></v-text-field>
                </v-flex>          
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
export default {
    data() {
        return {
            role_list: configs.ROLES,
            password: '',
            change_pass: false,
            bank_html: ''
        }
    },
    computed: {
        ...mapState({
            loading: state => state.users.loading,
            currentItem: (state) => state.users.selected,
        }),
        modifyId() {
            return this.$store.state.authentication.user.id;
        }
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("users/getDetail", this.modifyId);
            }
        },
        saveData() {
            if(this.change_pass) {
                this.currentItem.password = this.password
            }
            this.$store.dispatch("users/setDetail", {
                data: {
                    'phone': this.currentItem.phone,
                    'first_name': this.currentItem.first_name,
                    'email': this.currentItem.email,
                },
                id: this.currentItem.id,
                notify: 'Đã cập nhật profile.'
            });
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
